import {Injectable} from '@angular/core';
declare let OktaAuth: any;
import { ConfigService } from './config.service';
import { StorageService } from './storage.service';

@Injectable()
export class OktaService {

    public oktaClient: any
    oar?: any;

    constructor(private configService: ConfigService, private storageService: StorageService) { 
        this.oar = async () => { 
            if(window.location.pathname.indexOf('/login') < 0) {
                const activeSession = await this.checkForActiveSession();
                if (activeSession) {
                    await this.oktaSignInWithRedirect();
                } else {
                    window.location.replace(`${window.location.origin}/login`);
                }
            }
        }
        this.oktaClient = (this.createAuthClient())
    }

    async oktaSignInWithRedirect() {
        try {
          await this.oktaClient.signInWithRedirect();
        } catch (e) { }
    }

    checkForActiveSession() {
        try {
            const cookie = this.getCookie('mkp-session');
            const cookieClaims = cookie && cookie.length && JSON.parse(cookie);

            if (cookieClaims && cookieClaims.username) {
                return true
            }
        } catch (e) { }

        return false;
    }

    checkForExistingOktaToken() {
        const oktaTokenStorage = this.storageService.get('okta-token-storage');
        const accessTokenData = oktaTokenStorage && oktaTokenStorage['accessToken'];
        const accessToken = accessTokenData && accessTokenData['accessToken']
        return accessToken;

    }

    async checkForSessionMismatch() {
        try {
            const cookie = this.getCookie('mkp-session');
            const cookieClaims = cookie && cookie.length && JSON.parse(cookie);

            if (cookieClaims && cookieClaims.username) {
                
                const oktaTokenStorage = this.storageService.get('okta-token-storage');
                const accessTokenData = oktaTokenStorage && oktaTokenStorage['accessToken'];
                const accessToken = accessTokenData && accessTokenData['accessToken'];
                const authTime = this.decodeToken(accessToken).auth_time;

                if (cookieClaims.authAt > authTime) { // stale session, must sign in with redirect
                    await this.oktaClient.signInWithRedirect()
                } 
            }
        } catch (e) { }

        return false;
    }

    getCookie(cname: string) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    decodeToken(token) {
        if (!token)
            return null;
        var base64 = token.split('.')[1];
        if (base64) {
            var jwtClaims = void 0;
            try {
                jwtClaims = JSON.parse(atob(base64));
                return jwtClaims;
            }
            catch (err) {
                // Malformed JWT
                return null;
            }
        }
        return null;
    }

    createAuthClient() {
        let authCLient = undefined;
        // The `OktaAuth` constructor can throw if the config is malformed
        try {
            authCLient = new OktaAuth({
                issuer: this.configService.get('okta').issuer,
                clientId: this.configService.get('okta').clientId,
                redirectUri: `${window.location.origin}/login/callback`,
                scopes: ['openid', 'profile', 'offline_access']
            });
            //   if (config.startService) {
                authCLient.start();
            //   }
        } catch (error) {
          return alert(error);
        }
    
        return authCLient
    }

    get onAuthRequired() {
        return this.oar;
    }

    get client() {
        return this.oktaClient;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/okta.service.ts